var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.28 71.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#21222c;}.cls-2{fill:#50a471;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 35.64,
    cy: 35.64,
    r: 35.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,49.35V21.91c0-.2.08-.4.13-.59A3,3,0,0,1,22.2,19q13.46,0,26.92,0a3.05,3.05,0,0,1,3.16,3.28V48.37c0,.4,0,.8-.06,1.2a2.94,2.94,0,0,1-2.34,2.61l-.5.1H21.93a1.43,1.43,0,0,0-.27-.09,3,3,0,0,1-2.57-2.38C19.07,49.66,19,49.5,19,49.35ZM37.3,33.12c0-.3,0-.64,0-1a.87.87,0,0,0-1-1H32.73a.89.89,0,0,0-1,1V47.63a.91.91,0,0,0,1,1h3.51a.92.92,0,0,0,1-1.06c0-2.62,0-5.25,0-7.87a5.56,5.56,0,0,1,.56-2.44,2.67,2.67,0,0,1,2.78-1.57,2.44,2.44,0,0,1,2.27,2,8.59,8.59,0,0,1,.25,1.89c0,2.69,0,5.37,0,8.06a.89.89,0,0,0,1,1h3.64c.69,0,1.06-.35,1-1,0-3.17,0-6.33-.06-9.5a10.3,10.3,0,0,0-.69-3.67A5.19,5.19,0,0,0,45,31.33,8.08,8.08,0,0,0,41.49,31a5.41,5.41,0,0,0-2.83.95C38.18,32.27,37.75,32.71,37.3,33.12Zm-13.51,6.8v7.64a1,1,0,0,0,1.09,1.1h3.25c.9,0,1.23-.33,1.23-1.24V32.28a1,1,0,0,0-1.09-1.1H24.86a.93.93,0,0,0-1.07,1.07ZM30.15,26.2a3.59,3.59,0,1,0-7.17,0,3.59,3.59,0,1,0,7.17,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCircle);
export default __webpack_public_path__ + "static/media/linkedin-circle.5083c1af6b6444540197931466379d9e.svg";
export { ForwardRef as ReactComponent };